export default "__VITE_ASSET__CIT59LyA__"